import { Pipe, PipeTransform } from '@angular/core';

/**
 * Removes ISBD punctuation that MARC records carry at the edges of a field
 * (" :", " /", ",", ".", ";" and Arabic equivalents) so titles and authors
 * display cleanly. Inner punctuation is left untouched.
 */
export function cleanIsbd(value: string | null | undefined): string {
  if (!value) return '';
  return value
    .replace(/^[\s:/,.;،؛=+\-]+/, '')
    .replace(/[\s:/,.;،؛=+\-]+$/, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

@Pipe({ name: 'cleanIsbd', standalone: true })
export class CleanIsbdPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return cleanIsbd(value);
  }
}
